import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useConfig } from "../config";
import { createApiClient, type ApiClient } from "./client";

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

/** The nearest provided client (the signed-in dashboard's), or an anonymous one for public pages. */
export function useApi(): ApiClient {
  const provided = useContext(ApiContext);
  const { apiUrl } = useConfig();
  const anonymous = useMemo(() => createApiClient(apiUrl), [apiUrl]);
  return provided ?? anonymous;
}
